<div class="container-fluid full-height"  *ngIf="!appConfig.showconsumption">
    <div class="selects-container col-4 col-md-5 no-padding">
        <div class="col-sm-12 no-padding">
            <h3 class="select_consumption mt-3 mb-4">{{ 'CONSUMPTION.SELECT.NEW_CONSUMPTION' | translate }}</h3>
        </div>
        <form [formGroup]="consumptionForm" name="consumptionForm" (ngSubmit)="onSubmit(consumptionForm.value, cancelmodal)" #ngForm="ngForm">
            <div class="col-sm-12 no-padding">
                <div class="form-group">
                    <div class="dropdown dropdown-bhp" >
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input class="dropdown-toggle" type="text"
                            [ngModel]="nrSelect" formControlName="year" readonly
                            [ngClass]="{ 'is-invalid':consumptionForm.get('year').errors && (consumptionForm.get('year').touched || consumptionForm.get('year').dirty || ngForm.submitted)}" />
                            <span class="label-dropdown">{{ 'CONFIGURE.YEAR' | translate }}*</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [value]="currentYear" class="dropdown-item" *ngFor="let prevYear of previousYears"
                                (click)="onYearChange(prevYear)"
                                [ngClass]=" consumptionForm.get('year').value === prevYear ? 'active' : ''">
                                {{ prevYear }}
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="consumptionForm.get('year').errors && (consumptionForm.get('year').touched || consumptionForm.get('year').dirty || ngForm.submitted)">
                        <span *ngIf="consumptionForm.get('year').errors.required">
                        {{'ERROR_MESSAGES.REQUIRED.YEAR' | translate}}
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 no-padding">
                <div class="form-group">
                    <div class="dropdown dropdown-bhp" >
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="wardID" hidden />
                            <input class="dropdown-toggle" type="text" formControlName="wardName" readonly (click)="onClickWardHandler($event)"
                            [ngClass]="{ 'is-invalid':consumptionForm.get('wardID').errors && (consumptionForm.get('wardID').touched || consumptionForm.get('wardID').dirty || ngForm.submitted)}" />
                            <span class="label-dropdown">{{ translationKeys.Configure.Ward | translate }}*</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="selectedWard" class="dropdown-item" *ngFor="let ward of wardDetails; let i = index"
                                (click)="onWardChange(ward)"
                                [ngClass]=" consumptionForm.get('wardName').value === ward.wardName ? 'active' : ''">
                                {{ ward.wardName | translate | labelSanitizer }}
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="consumptionForm.get('wardID').errors && (consumptionForm.get('wardID').touched || consumptionForm.get('wardID').dirty || ngForm.submitted)">
                        <span *ngIf="consumptionForm.get('wardID').errors.required">
                            {{translationKeys.ErrorMessages.RequiredWard | translate}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 no-padding mb-5">
                <div class="form-group">
                    <label>{{ translationKeys.Configure.Department | translate }}</label>
                    <p>{{consumptionForm.get('departmentID').value.departmentName | translate}} {{ getDepartmentTypeName(consumptionForm.get('wardID').value) }}</p>
                </div>
            </div>


            <div class="alert alert-warning" role="alert" *ngIf="wardWarningMessage && (userData.roleName.roleId == 5)">
                <img class="alert-image" src="assets/img/icons/InfoOutlined.svg" />
                <p class="m-0">{{ 'CONFIGURE.NOT_CONFIGURED_CONTACT_INSTITUTION_ADMIN.WARD' | translate }}</p>
            </div>

            <div class="alert alert-warning" role="alert" *ngIf="wardWarningMessage && (userData.roleName.roleId == 4)">
                <img class="alert-image" src="assets/img/icons/InfoOutlined.svg" />
                <p class="m-0">{{ 'CONFIGURE.NOT_CONFIGURED_REFERENCE_CONFIGURATION.WARD' | translate }}</p>
            </div>

            <div class="alert alert-warning" role="alert" *ngIf="!consumptionConfigDetail && (userData && userData.roleName.roleId == 5)">
                <img class="alert-image" src="assets/img/icons/InfoOutlined.svg" />
                <p class="m-0">{{'CONFIGURE.NOT_CONFIGURED_CONTACT_INSTITUTION_ADMIN.CONSUMPTION_DETAILS' | translate }}</p>
            </div>

            <div class="alert alert-warning" role="alert" *ngIf="!consumptionConfigDetail &&  (userData &&  userData.roleName.roleId == 4)">
                <img class="alert-image" src="assets/img/icons/InfoOutlined.svg" />
                <p class="m-0">{{'CONFIGURE.NOT_CONFIGURED_REFERENCE_CONFIGURATION.CONSUMPTION_DETAILS' | translate }}</p>
            </div>

            <button *ngIf="!wardWarningMessage  && consumptionConfigDetail" class="btn-continue-bordered-bd">
                {{ 'SOP_OBSERVATION.CONTINUE' | translate }}
            </button>

        </form>

    </div>
</div>
<ng-template #cancelmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>
    <div class="modal-body">
        <p> {{ 'CONSUMPTION.CONSUMPTION.ALREADY_EXISTS' | translate }} </p>
        <p> {{ 'CONSUMPTION.QUESTION_NAVIGATE_EXISTING_PAGE' | translate }} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide();" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="openviewconsumption()" class="btn-bd-empty">{{ 'CONFIGURE.EDIT' | translate }}</button>
        </div>
    </div>
</ng-template>

<div *ngIf="appConfig.showconsumption">
    <div *ngIf="navTo === 'm'">
        <lib-ph-bhp-month-consumption [userData]='userData' [formdata]="consumptionForm.value" (childData)="onChildData($event)"></lib-ph-bhp-month-consumption>
    </div>
    <div *ngIf="navTo === 'y'">
        <lib-ph-bhp-year-consumption [userData]='userData' [formdata]="consumptionForm.value" (childData)="onChildData($event)"></lib-ph-bhp-year-consumption>
    </div>
    <div *ngIf="navTo === 'q'">
        <lib-ph-bhp-quarter-consumption [userData]='userData' [formdata]="consumptionForm.value" (childData)="onChildData($event)"></lib-ph-bhp-quarter-consumption>
    </div>
</div>
